module.exports = __webpack_public_path__ + "static/media/ajax-Loader.1dbafa0a.gif";